import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SettingsContext = createContext(null);

const DEFAULT_SETTINGS = {
  schoolName: "תלמוד תורה אור התורה",
  schoolNameEn: "OHR HATORAH",
  schoolAddress: "",
  schoolPhone: "",
  adminName: "הרב יוסף גאלדבערגער",
  showLogoOnReceipt: true,
  showSignatureLine: true,
  receiptFooter: "",
  reasonShortcuts: ["פארשלאפן", "דאקטער אפאינטמענט", "טראנספארט פראבלעם", "משפחה עמערזענסי"],
  commonReasons: [
    { text: "דאקטער אפאינטמענט", category: "justified" },
    { text: "צאהנארזט אפאינטמענט", category: "justified" },
    { text: "דאקטערס באזוך", category: "justified" },
    { text: "משפחה עמערזענסי", category: "justified" },
    { text: "שמחה משפחתית", category: "justified" },
    { text: "טראנספארט פראבלעם", category: "unjustified" },
    { text: "פארשלאפן", category: "unjustified" },
    { text: "אנדערע", category: "justified" },
  ],
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/settings`);
      setSettings({ ...DEFAULT_SETTINGS, ...res.data });
      return res.data;
    } catch (e) {
      console.error("Failed to load settings", e);
      return DEFAULT_SETTINGS;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const updateSettings = useCallback(async (patch) => {
    const res = await axios.put(`${API}/settings`, patch);
    setSettings({ ...DEFAULT_SETTINGS, ...res.data });
    return res.data;
  }, []);

  const resetSettings = useCallback(async () => {
    const res = await axios.post(`${API}/settings/reset`);
    setSettings({ ...DEFAULT_SETTINGS, ...res.data });
    return res.data;
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, loading, refresh, updateSettings, resetSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  const ctx = useContext(SettingsContext);
  if (!ctx) throw new Error("useSettings must be used within SettingsProvider");
  return ctx;
}
